/* eslint-disable camelcase */
import { useIntl } from 'react-intl';

import { CPDashboardTabProps, TabState } from './types';

import * as S from './styles';

enum TabName {
  critical = 'CPPLATFORM.MONITORING.CRITICALTITLE',
  will_be_unlinked = 'CPPLATFORM.MONITORING.UNLINKEDTITLE',
}

const CPDashboardTab: React.FC<CPDashboardTabProps> = ({
  name,
  state,
  amount,
  onSelect,
}) => {
  const intl = useIntl();

  const handleTabSelection = () => {
    onSelect(name);
  };

  const nameKey = TabName[name];

  return (
    <S.Wrapper
      onClick={handleTabSelection}
      isActive={state === TabState.ACTIVE}
      disabled={state === TabState.DISABLED}
    >
      <S.Amount>{amount}</S.Amount>
      <S.Text>{intl.formatMessage({ id: nameKey })}</S.Text>
    </S.Wrapper>
  );
};

export default CPDashboardTab;
